import React from 'react'

import { Loader } from "@progress/kendo-react-indicators";

interface LoaderProps{
  fullScreen:boolean
}
export default function LoaderSpinner(props:LoaderProps){

  return (
    <div className='theme-spinner flex justify-center m-20'>
      <div className='mx-auto'>
        <Loader 
        className='theme-infinite-spinner'
        type="infinite-spinner"
        size='large'
         />
      </div>
    </div>
  )

};
